import { Injectable, Renderer2, RendererFactory2 } from '@angular/core'
import { WithResponseHeaders } from '@ftr/api-shared'
import { ApiResult, tapFailure, ToastService, unwrapData } from '@ftr/foundation'
import { WindowRefService } from '@ftr/window'
import { take } from 'rxjs'
import { getExportFilename, isTruncatedResponse } from '../utils'

@Injectable({
  providedIn: 'root',
})
export class ExportDownloadAuditLogService {
  private renderer: Renderer2

  constructor(
    private readonly windowRefService: WindowRefService,
    private readonly rendererFactory: RendererFactory2,
    private readonly toastService: ToastService,
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null)
  }

  public onExport(result: ApiResult<WithResponseHeaders<Blob>>, filename: string): void {
    result
      .pipe(
        take(2),
        tapFailure(_ => {
          this.toastService.error('Failed to generate audit export CSV.')
        }),
        unwrapData(),
      )
      .subscribe(({ data, headers }) => {
        const exportFilename = getExportFilename(headers, filename)
        const exportDownload: HTMLAnchorElement = this.renderer.createElement('a')
        exportDownload.href = this.windowRefService.nativeWindow().URL.createObjectURL(data)
        exportDownload.setAttribute('download', exportFilename)
        exportDownload.click()
        exportDownload.remove()

        if (isTruncatedResponse(headers)) {
          this.toastService.warning(`
            Your export contains too many rows and has been truncated.
            Use the filters to reduce your number of results.
            Exported audit log to ${exportFilename}.
          `)
        } else {
          this.toastService.success(`Exported audit log to ${exportFilename}.`)
        }
      })
  }
}
